import { useTheme } from '../theme';

export function useCardStyles() {
  const { theme } = useTheme();
  const isDark = theme.isDark;

  return {
    isDark,
    container: [
      'rsc-entity-card group relative flex flex-col gap-2 rounded-2xl border p-4 backdrop-blur-md transition-all duration-200',
      isDark
        ? 'bg-gray-900/70 border-gray-700/30 shadow-sm hover:border-[var(--rsc-primary)] hover:shadow-xl hover:shadow-black/20'
        : 'bg-white/70 border-white/20 shadow-sm hover:border-[var(--rsc-primary)] hover:shadow-xl hover:shadow-black/5',
    ].join(' '),
    label: isDark ? 'text-gray-400' : 'text-gray-500',
    title: isDark ? 'text-white' : 'text-gray-900',
    subtle: isDark ? 'text-gray-500' : 'text-gray-400',
    muted: isDark ? 'text-gray-300' : 'text-gray-700',
    border: isDark ? 'border-gray-700/30' : 'border-white/20',
    surface: isDark ? 'bg-gray-900/60' : 'bg-gray-50/70',
  };
}
